module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg27.e9a09918.jpg";